"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TravelAgentStatus = void 0;
var TravelAgentStatus;
(function (TravelAgentStatus) {
    TravelAgentStatus[TravelAgentStatus["Pending"] = 0] = "Pending";
    TravelAgentStatus[TravelAgentStatus["Approved"] = 1] = "Approved";
    TravelAgentStatus[TravelAgentStatus["Declined"] = 2] = "Declined";
})(TravelAgentStatus || (exports.TravelAgentStatus = TravelAgentStatus = {}));
//# sourceMappingURL=TravelAgentStatus.js.map